import React, { useState, useEffect } from "react";
import ReusableTable from "../../components/Employee/Table";
import {
  confirmDeletePopup,
  formatDateOnly,
  openDeductionTypeModal,
  successPopup,
} from "../../util/common";
import TextInput from "../../components/Reusable/TextInput";
import SelectInput from "../../components/Reusable/SelectInput";
import DateInput from "../../components/Reusable/DateInput";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";
import {
  useCreateNewDeductionType,
  useDeleteDeductionType,
  useGetAllDeductionTypesPaginated,
  useGetDeductionTypeById,
  useUpdateDeductionType,
} from "../../hooks/usePayroll";
import { toast } from "react-toastify";

function DeductionListLayout() {
  const [pageCount, setPageCount] = useState(1);
  const navigate = useNavigate();

  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 20,
  });

  const [filter, setFilter] = useState({
    filterField1: "Code",
    filterValue1: null,
  });

  const handleOnPageChange = (pageIndex, pageSize) => {
    setPagination({
      page: pageIndex + 1,
      pageSize,
    });
  };

  const [deductionTypeRecords, setDeductionTypeRecords] = useState([]);
  const deductionTypes = useGetAllDeductionTypesPaginated();
  const createDeductionType = useCreateNewDeductionType();
  const _deductionType = useGetDeductionTypeById();
  const updateDeductionType = useUpdateDeductionType();
  const deleteDeductionType = useDeleteDeductionType();

  const fetchDeductionTypeRecords = async () => {
    deductionTypes.mutate(
      {
        page: pagination.page,
        pageSize: pagination.pageSize,
        filterField1: filter.filterField1,
        filterValue1: filter.filterValue1,
      },
      {
        onSuccess: async (result) => {
          if (!result.success) return;
          setDeductionTypeRecords(result.data.data);
          setPageCount(result.data.pagination.totalPages);
        },
      }
    );
  };

  useEffect(() => {
    fetchDeductionTypeRecords();
  }, [pagination, filter]);

  const handleEdit = (deductionType) => {
    if (!deductionType) return;

    _deductionType.mutate(deductionType.id, {
      onSuccess: async (data) => {
        if (!data?.success) return;

        const { id, Code, Description, Statutory } = data.data;

        const result = await openDeductionTypeModal({
          id,
          code: Code,
          description: Description,
          statutory: Statutory,
        });

        if (!result) return;

        updateDeductionType.mutate(
          {
            id: result.id,
            code: result.code,
            description: result.description,
            statutory: result.statutory,
          },
          {
            onSuccess: (res) => {
              if (res?.success) {
                toast.success(res.message);
                fetchDeductionTypeRecords();
              }
            },
            onError: (err) => {
              toast.error(err.response?.data?.message || "Error occurred");
            },
          }
        );
      },
    });
  };

  const handleDelete = async (deductionType) => {
    const isConfirmed = await confirmDeletePopup({
      text: `Are you sure you want to delete ${deductionType.Code}?`,
    });

    if (isConfirmed) {
      deleteDeductionType.mutate(deductionType.id, {
        onSuccess: (data) => {
          successPopup("Deduction Type deleted successfully.");
        },
      });
    }
  };

  const tableColumns = [
    { accessorKey: "Code", header: "Code" },
    { accessorKey: "Description", header: "Description" },
    { accessorKey: "Statutory", header: "Statutory" },
    { accessorKey: "Active", header: "Active" },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => {
        const deductionType = row.original;

        return (
          <div style={{ display: "flex", gap: "10px" }}>
            <FaEdit
              title="Edit"
              style={{ cursor: "pointer" }}
              onClick={() => handleEdit(deductionType)}
            />

            <FaTrash
              title="Delete"
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => handleDelete(deductionType)}
            />
          </div>
        );
      },
    },
  ];

  const handleAddDeductionType = async () => {
    const result = await openDeductionTypeModal({
      id: "",
      code: "",
      description: "",
      statutory: false,
    });

    if (!result) return;

    createDeductionType.mutate(
      {
        code: result.code,
        description: result.description,
        statutory: result.statutory,
      },
      {
        onSuccess: (data) => {
          if (data?.success) {
            toast.success(data.message);
            fetchDeductionTypeRecords();
          }
        },
        onError: (err) => {
          toast.error(err.response?.data?.message || "Error occurred");
        },
      }
    );
  };

  return (
    <div className="overtime-form-container">
      <h2>Deduction Types List</h2>
      <form className="overtime-form">
        <div className="form-column">
          <TextInput
            label="Code Name"
            placeholder={"ALLOW-001"}
            onChange={(val) => {
              setFilter((prev) => ({
                ...prev,
                filterValue1: val,
              }));
            }}
            value={filter.filterValue1}
          />
        </div>

        <div className="form-group full-width file-upload-section">
          <div className="attendance-filters">
            <div className="action-btns">
              <button
                className="overtime-btn"
                onClick={handleAddDeductionType}
                type="button"
              >
                + Add Deduction Type
              </button>
            </div>
            <div className="attendance-records">
              <ReusableTable
                data={deductionTypeRecords}
                columns={tableColumns}
                mode="server"
                initialPageSize={pagination.pageSize}
                onPageChange={handleOnPageChange}
                pageCount={pageCount}
                page={pagination.page - 1}
                pageSize={pagination.pageSize}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default DeductionListLayout;
